/**
 * MuiDialog
 *
 * Styles:
 *
 * - [Proto](https://www.figma.com/file/gImnv1p0uOIizS33dnZJa9/Patient-App-2.0?node-id=572%3A29381&mode=dev)
 */
const MuiDialog = {
  styleOverrides: {
    container: () => ({
      '& > .MuiPaper-root > .MuiButtonBase-root > [data-testid="CloseIcon"]': {
        fontSize: 40
      }
    })
  }
};
export const MuiDialogTitle = {
  defaultProps: {
    variant: 'h2'
  },
  styleOverrides: {
    root: ({
      theme
    }) => ({
      padding: theme.spacing(5),
      '&.MuiTypography-h2': {
        textAlign: 'center',
        '& > .MuiSvgIcon-root': {
          color: theme.palette.grey[600],
          fontSize: 40,
          mb: 1
        }
      }
    })
  }
};
export const MuiDialogActions = {
  styleOverrides: {
    spacing: ({
      theme
    }) => ({
      paddingLeft: theme.spacing(2.5),
      paddingRight: theme.spacing(2.5)
    })
  }
};
export default MuiDialog;